<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.detailInvert')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="detail" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <vxe-input v-model="detail.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="detail.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.specification')">
            <vxe-input v-model="detail.pack.specification" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.uom')">
            <vxe-input v-model="detail.pack.uom" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.factor')">
            <vxe-input v-model="detail.pack.factor" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.plannedQuantity')">
            <vxe-input v-model="detail.plannedQuantity" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.actualQuantity')">
            <vxe-input v-model="detail.actualQuantity" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('business.label.inverseQuantity')">
            <vxe-number-input v-model="inverseQuantity" :max="detail.plannedQuantity" :min="0" placeholder="business.label.inverseQuantity" style="width: 100%" @change="change"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { post } from '@/api/Api'
import { ShipmentDetail } from '@/api/dto/order/ShipmentOrder'
import { BaseObject } from '@/api/dto/BaseObject'
import api from '@/api'

export default {
  name: 'DetailInversionEditor',
  props: {
    directions: { type: Array, default: () => [] },
    idTypes: { type: Array, default: () => [] },
    regions: { type: Array, default: () => [] }
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      detail: new ShipmentDetail(),
      inverseQuantity: 0
    }
  },
  methods: {
    open(record) {
      this.detail = new ShipmentDetail(BaseObject.merge(record, 'detail'))
      this.inverseQuantity = parseFloat(this.detail.plannedQuantity) - parseFloat(this.detail.actualQuantity)
      this.visible = true
    },
    change() {
      this.detail.actualQuantity = parseFloat(this.detail.plannedQuantity) - parseFloat(this.inverseQuantity)
    },
    confirm() {
      this.$refs.form.validate(() => {
        this.loading = true
        const args = [{ id: this.detail.id, actualQuantity: this.detail.actualQuantity }]
        post(api.dispatchInvertDetail, {}, { details: args }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.operationSuccess'))
            this.$emit('success')
            this.visible = false
          }
        }).finally(() => this.loading = false)
      })
    }
  }
}
</script>